import PageNotFoundMessage from './PageNotFoundMessage'

export default PageNotFoundMessage
